import CardSection from "../CardSection"
import DetailsCard from "../DetailsCard"
import InputField from "../InputField"

interface Props {
    filterValue: string
    onFilterChange: (value: string) => void
}

const CreditFacilityPayoutFilter = ({filterValue, onFilterChange}: Props) => {
 
    return (
        <CardSection>
            <DetailsCard>
            <InputField
                id="creditFacilityPayoutSearchField"
                placeholder="Search payouts..."
                value={filterValue || ''}
                onEnterKeyOrBlur={value => onFilterChange(value)}
            />
            </DetailsCard>
        </CardSection>
    )
}

export default CreditFacilityPayoutFilter
